import { gql } from '__generated__'

export const GetOfficeLocationsByName = gql(/* GraphQL */ `
    query GetOfficeLocationsByName($name: String, $page: Float, $limit: Float) {
        officeLocations(name: $name, page: $page, limit: $limit) {
            data {
                id
                value
            }
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
        }
    }
`)

export const GetOfficeLocationsById = gql(/* GraphQL */ `
    query GetOfficeLocationsById($ids: [ID!]!) {
        officeLocationsById(ids: $ids) {
            id
            value
        }
    }
`)
